import InfoIconsCamera from '@/modules/device-module/components/header/InfoIconsCamera'
import {
  useGetDeviceDetailQuery,
  useGetPhotosDetailQuery,
} from '@/modules/device-module/services/deviceService'
import { Box } from '@mui/material'
import Paper from '@mui/material/Paper'
import * as React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { DeviceType } from '@/types/enums'
import ActionMenu from './ActionMenu'
import InfoIcons from './InfoIcons'
import InfoIconsDit from './InfoIconsDit'
import InfoIconsDetector from './InfoIconsDetector'
import Title from './Title'
import WarningMessage from './WarningMessage'

const Header = () => {
  const { id } = useParams()
  const { pathname } = useLocation()

  const { data } = useGetDeviceDetailQuery(Number(id), {
    skip: pathname.includes('photos'),
  })
  const { data: photosData } = useGetPhotosDetailQuery(Number(id), {
    skip: !pathname.includes('photos'),
  })
  const isDetector = data?.typeId === DeviceType.detector
  return (
    <Paper
      elevation={6}
      style={{ backgroundColor: 'transparent' }}
      sx={{ boxShadow: 'unset', pb: { xss: 0, lg: 0 } }}
    >
      <Box
        display='flex'
        flexDirection='column'
        p={2}
        pt={{ xss: 0, lg: 1 }}
        pb={0}
      >
        <Box
          display='flex'
          justifyContent='space-between'
          flexWrap='wrap'
        >
          <Title />
          {data?.typeId === DeviceType.dit && <InfoIconsDit />}
          {isDetector && <InfoIconsDetector />}
          {data?.smart ? (
            <InfoIcons />
          ) : data?.typeId === DeviceType.photo ||
            data?.typeId === DeviceType.video ||
            photosData?.typeId === DeviceType.photo ? (
            <InfoIconsCamera />
          ) : null}
        </Box>
        <Box
          display='flex'
          justifyContent='space-between'
          flexWrap='wrap'
          pt={{ xss: 0, lg: 0.5 }}
          pb={{ xss: 0, lg: 0.5 }}
        >
          <ActionMenu />
          {data?.typeId === DeviceType.photo ||
          data?.typeId === DeviceType.kao ||
          data?.typeId === DeviceType.ksodd ||
          data?.typeId === DeviceType.video ||
          data?.typeId === DeviceType.dit ||
          photosData?.typeId === DeviceType.photo ? null : (
            <>{data?.state ? <WarningMessage /> : null}</>
          )}
        </Box>
      </Box>
    </Paper>
  )
}

export default Header
